import { Theme } from '@emotion/react';
import { FC, PropsWithChildren } from 'react';

interface ShippingOptionLogoWrapperProps {
  size?: number;
}

export const ShippingOptionLogoWrapper: FC<PropsWithChildren<ShippingOptionLogoWrapperProps>> = ({
  size = 30,
  children,
}) => <div css={styles.wrapper(size)}>{children}</div>;

export const styles = {
  wrapper: (size: number) => (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: `${size}px`,
    width: `${size}px`,
    minWidth: `${size}px`, // fix for IE11
    backgroundColor: theme.white,
    borderRadius: '50%',
  }),
};
